// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1D9ys","title":"AfterBackImages_title__1eg7v","images":"AfterBackImages_images__aXbT7"};